module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hotdiss-container"
  }, [_c('div', {
    staticClass: "hotdiss-header"
  }, [_vm._v("热门歌单")]), _vm._v(" "), _c('div', {
    staticClass: "hotdiss-body"
  }, _vm._l((_vm.disslist), function(item) {
    return _c('div', {
      staticClass: "hotdiss-item-box"
    }, [_c('router-link', {
      attrs: {
        "to": "/"
      }
    }, [_c('div', {
      staticClass: "diss-cover",
      style: (item.style)
    }), _vm._v(" "), _c('div', {
      staticClass: "info-mask"
    }, [_c('div', {
      staticClass: "diss-name"
    }, [_vm._v(_vm._s(item.dissname))]), _vm._v(" "), _c('div', {
      staticClass: "listennum"
    }, [_vm._v("已播放" + _vm._s(item.listennum) + "次")])])])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5fa3d3b7"}!./~/._vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Index/hotdiss.vue
// module id = 160
// module chunks = 1